/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    RECEIVE_COMMENTING_DATA,
    COMMENTING_DATA_FAIL,
    COMMENT_REQUEST_PENDING,
    FETCHING_COMMENT_DATA,
    SELECT_SITE,
    RECEIVE_COMMENTING_UNIT_CHECK,
    APPROVING_COMMENTING,
    COMMENT_REQUEST_SENT,
    RECEIVE_COMMENTING_EMAIL_IF_EXIST
} from 'state/actions/commentingState/commentingStatus';



/* ========== ~~~~~~~~~~  OVERLAY STATUS : REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    fetchingCommentData: false,
    isDataReceived: false,
    dataFetchFailed: false,
    requestPending: false,
    requestStatus: null,
    commentEmailSentTo: null,
    selectedSite: null,
    hasCommentingUnit: null,
    approving: false,
    commentingEmailAlreadyExist: false
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const commentingStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {
        case RECEIVE_COMMENTING_DATA:
            newState.requestStatus = action.requestStatus;
            newState.commentEmailSentTo = action.userEmail;
            newState.isDataReceived = true;
            newState.dataFetchFailed = false;
            newState.hasCommentingUnit = true;
            return newState;
        case COMMENTING_DATA_FAIL:
            newState.dataFetchFailed = true;
            return newState;
        case COMMENT_REQUEST_SENT:
            newState.requestStatus = 'PENDING';
            newState.commentEmailSentTo = action.userEmail;
            newState.isDataReceived = true;
            newState.dataFetchFailed = false;
            newState.hasCommentingUnit = true;
            return newState;
        case COMMENT_REQUEST_PENDING:
            newState.requestPending = action.status;
            return newState;
        case FETCHING_COMMENT_DATA:
            newState.fetchingCommentData = action.status;
            return newState;
        case SELECT_SITE:
            newState.selectedSite = action.site;
            return newState;
        case RECEIVE_COMMENTING_UNIT_CHECK:
            newState.hasCommentingUnit = action.state;
            newState.requestStatus = action.state ? 'APPROVED' : newState.requestStatus;
            newState.commentEmailSentTo = action.state ? 'info@insticator.com' : newState.commentEmailSentTo;
            newState.isDataReceived = true;
            newState.dataFetchFailed = false;
            newState.fetchingCommentData = false;
            return newState;
        case APPROVING_COMMENTING:
            newState.approving = action.status;
            return newState;
        case RECEIVE_COMMENTING_EMAIL_IF_EXIST:
            newState.commentingEmailAlreadyExist = action.isExist;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default commentingStatus;
